export function sanitizeNotificationBody(body) {
  if (!body) return '';
  let text = String(body);
  text = text.replace(/https?:\/\/[^\s<>"']+/gu, '');
  text = text.replace(
    /(^|[\s:：.،])\/(?:meetings|tasks|action-items|billing|reports|bookings|minutes|invite|profile|security|settings|users|organizations|dashboard)[^\s<>"']*/gu,
    '$1',
  );
  text = text.replace(
    /(^|[\s:：.،])(?:meetings|tasks|action-items)\/[0-9a-fA-F-]{8,}[^\s<>"']*/gu,
    '$1',
  );
  text = text.replace(/(?:ورود|پرداخت|دریافت|مشاهده و پرداخت)\s*:\s*/gu, '');
  text = text.replace(/[ \t]{2,}/g, ' ');
  text = text.replace(/\s+([.،])/g, '$1');
  return text.replace(/^[\s:：]+|[\s:：]+$/g, '').trim();
}

export function notificationActions(notification) {
  const actions = Array.isArray(notification?.actions)
    ? notification.actions.filter((item) => item?.url && item?.label)
    : [];
  if (actions.length) return actions;
  if (notification?.action_url) {
    const url = String(notification.action_url);
    return [{
      label: 'مشاهده جزئیات',
      url,
      external: !url.startsWith('/'),
    }];
  }
  return [];
}

export function openNotificationUrl(url, navigate) {
  if (!url) return;
  if (url.startsWith('/')) {
    navigate(url);
    return;
  }
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) {
      navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`);
      return;
    }
  } catch {
    // fall through to a new tab
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
